import React, { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import i18n from 'i18n';
import { AbilityContext } from 'utils/ability/abilityContext';
import { useHistory } from 'react-router-dom';
import { get } from 'lodash';
import { withTheme } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import {
  ENRICHMENT_MY_CLASS_LIST,
  ENRICHMENT_OVERVIEW,
  MY_DOWNLOADS,
  ENRICHMENT_PARENT_PAYMENT,
} from 'routes/constants';
import { getQueryParams } from 'utils';
import {
  EP_REPORT_ROLE_OPTIONS,
  SUPER_ADMIN_ROLE,
  HQ_ROLE,
  ADMIN_ROLE,
  VENDOR_ADMIN,
  VENDOR_TRAINER,
  PRINCIPAL_ROLE,
  L1_SUPPORT_LEAD_ROLE,
  SUPPORT_ROLE,
  FINANCE,
} from 'utils/constants';
import DesktopSidemenu from './DesktopSidemenu';
import MobileSidemenu from './MobileSidemenu';

const Sidemenu = props => {
  const ability = useContext(AbilityContext);
  const roleLabel = useSelector(state =>
    get(state, 'userDetails.data.userRoleRelations.data[0].role.label')
  );
  const getClassDecisionLabelVendor = (label, path) =>
    ability.can('canMarkAttendance', roleLabel) &&
    label.includes(i18n.t('enrichment_class.classManagement')) &&
    !path.includes('myclasses')
      ? i18n.t('enrichment_class.classDecision')
      : label;
  const history = useHistory();
  const { theme, userDetails, pathname } = props;

  const getLogo = () => {
    let logo = '';
    if (get(theme, 'logo')) {
      logo = theme.logo;
    }
    return logo;
  };

  const sidemenuData = useSelector(state => get(state, 'sidemenu.data', []));

  const filteredSidemenu = useMemo(() => {
    const userRole = get(userDetails, 'userRoleRelations.data[0].role');
    const isFinance = get(userRole, 'label') === FINANCE;
    const isHQ = get(userRole, 'label') === HQ_ROLE;
    const hasEpReportsAccess = EP_REPORT_ROLE_OPTIONS.includes(
      get(userDetails, 'userRoleRelations.data[0].role.label')
    );
    const hasEpVendorManagementAccess = [
      SUPER_ADMIN_ROLE,
      HQ_ROLE,
      L1_SUPPORT_LEAD_ROLE,
      SUPPORT_ROLE,
    ].includes(get(userDetails, 'userRoleRelations.data[0].role.label'));
    const hasEpChildPerformanceAccess = [
      SUPER_ADMIN_ROLE,
      HQ_ROLE,
      ADMIN_ROLE,
      VENDOR_ADMIN,
      VENDOR_TRAINER,
      PRINCIPAL_ROLE,
    ].includes(get(userDetails, 'userRoleRelations.data[0].role.label'));

    return sidemenuData.map(menuItem => {
      if (menuItem.label === 'Enrichment Programme' && menuItem.submenu) {
        return {
          ...menuItem,
          submenu: menuItem.submenu.filter(subItem => {
            if (
              !ability.can('approve', 'enrichment_management') &&
              !subItem.label.includes('Finance') &&
              isFinance
            ) {
              return false;
            }
            if (
              isFinance &&
              ['Class Decisions', 'Users'].includes(subItem.label)
            ) {
              return false;
            }
            if (!hasEpReportsAccess && subItem.label.includes('Reports')) {
              return false;
            }
            if (
              !hasEpVendorManagementAccess &&
              subItem.label.includes('Vendor Management')
            ) {
              return false;
            }
            if (
              !hasEpChildPerformanceAccess &&
              subItem.label.includes('Child Performance')
            ) {
              return false;
            }
            if (isHQ && subItem.label.includes('Users')) {
              return false;
            }
            if (isHQ && subItem.label.includes('Class Decisions')) {
              return false;
            }
            return true;
          }),
        };
      }
      return menuItem;
    });
  }, [sidemenuData, userDetails, ability]);

  const goToLink = link => {
    if (
      ENRICHMENT_OVERVIEW.includes(link) ||
      ENRICHMENT_MY_CLASS_LIST.includes(link) ||
      MY_DOWNLOADS.includes(link) ||
      ENRICHMENT_PARENT_PAYMENT.includes(link)
    ) {
      const searchParams = getQueryParams();
      history.push({
        pathname: `/${link}`,
        state: {
          child: get(searchParams, 'childID', get(searchParams, 'childId', '')),
          centre: get(searchParams, 'centreID', ''),
        },
      });
    } else {
      history.push(`/${link}`);
    }
  };
  return (
    <>
      <Hidden only="xs">
        <DesktopSidemenu
          getLogo={getLogo}
          goToLink={goToLink}
          getClassDecisionLabelVendor={getClassDecisionLabelVendor}
          sidemenu={filteredSidemenu}
        />
      </Hidden>
      <Hidden only={['xl', 'lg', 'md', 'sm']}>
        <MobileSidemenu
          userDetails={userDetails}
          getLogo={getLogo}
          theme={theme}
          pathname={pathname}
          sidemenu={filteredSidemenu}
          getClassDecisionLabelVendor={getClassDecisionLabelVendor}
          goToLink={goToLink}
        />
      </Hidden>
    </>
  );
};
export default withTheme(Sidemenu);
